// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2B_BT","label":"styles_label__3VGxV"};